// extracted by mini-css-extract-plugin
export var content = "_rc-1";
export var fullScreen = "_rc-0";